import React from 'react';
import { logout } from '@/services/account/logout';
import { useAppContext } from './useAppContext';

export const useLogout = () => {
  const { account, updateAppContext } = useAppContext();
  const [loggingOut, setLoggingOut] = React.useState(false);

  const handleLogout = React.useCallback(async () => {
    setLoggingOut(true);
    return logout()
      .then(() => {
        updateAppContext((prev) => ({
          ...prev,
          account: undefined,
          relations: undefined,
        }));
      })
      .finally(() => {
        setLoggingOut(false);
      });
  }, [account, updateAppContext]);

  return React.useMemo(
    () => ({ loggingOut, handleLogout }),
    [loggingOut, handleLogout],
  );
};
